import React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var ProviderReferralHeader = function ProviderReferralHeader(_ref) {
  var referrerUser = _ref.referrerUser;
  if (!referrerUser.firstName || !referrerUser.lastName) return null;
  return /*#__PURE__*/_jsxs("div", {
    className: "bg-green-100 py-4 text-gray-900 text-center",
    "data-cy": "ProviderReferralHeaderBanner",
    children: [/*#__PURE__*/_jsx("span", {
      className: "fw-500",
      children: "".concat(referrerUser.firstName, " ").concat(referrerUser.lastName, " ")
    }), "has invited you to launch your business on Subkit."]
  });
};

export default ProviderReferralHeader;